module.exports = __webpack_public_path__ + "img/image-titan.be591595.png";